<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { RouterLink, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import TopBarContent from '@/_company/components/TopBarContent.vue';

const { t } = useI18n();
const store = useStore();
const router = useRouter();
const user = computed(() => store.state.company.user.user);

const logoutUser = async () => {
  try {
    await store.dispatch('company/user/logout');
    router.push({ name: 'company-login' });
  } catch (error) {
    // eslint-disable-next-line no-console
    if (process.env.NODE_ENV === 'development') console.error(error);
  }
};
</script>

<template>
  <TopBarContent>
    <template v-slot:name>{{ user.name || user.personNumber }}</template>

    <template v-slot:profile-link>
      <RouterLink :to="{ name: 'company-profile' }">
        {{ t('topbar.dropdown.profile') }}
      </RouterLink>
    </template>

    <template v-slot:logout>
      <button @click="logoutUser()">{{ t('topbar.dropdown.logout') }}</button>
    </template>
  </TopBarContent>
</template>
